import {
  addCourseToWishList,
  getCourseEnroll,
  setCourseEditData,
} from '@/actions/courses';
import { getCourseWishlistByPage, setProfileData } from '@/actions/profile';
import { capitalizeFirstLetter, imagesLink } from '@/helpers/dataHelper';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { Badge, Card, Empty, Pagination, Rate, Skeleton } from 'antd';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { MyNewCourseCard } from './myCourse';

const CourseTabs = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const tab = router.pathname;
  const courses = useSelector(
    (state: any) => state.courses.courseEnroll?.data?.data
  );
  const enrollCourseQuery = useSelector(
    (state: any) => state.courses.courseEnroll?.data?.meta
  );

  const [removeSlug, setRemoveSlug] = useState(null);
  const [query, setQuery] = useState({
    page: 1,
    per_page: 12,
  });
  const [queries, setQueries] = useState({
    page: 1,
    per_page: 12,
  });

  const {
    myCourseLoading,
    addCourseWishlistStatus,
    wishlist,
    getCourseWishList,
    wishlistStatus,
    profileWishlistMeta,
  } = useSelector((state: any) => ({
    myCourseLoading: state.courses?.courseEnroll?.loading,
    addCourseWishlistStatus: state?.courses?.addCourseWishlistStatus,
    wishlist: state.profile.wishlist,
    getCourseWishList: state.profile.getCourseWishList,
    wishlistStatus: state?.courses?.courseDetail?.data?.wishlist,
    profileWishlistMeta: state?.profile?.wishlist?.meta,
  }));

  useEffect(() => {
    return () => setRemoveSlug(null);
  }, []);

  useEffect(() => {
    if (tab === '/profile/my-course') {
      dispatch(getCourseEnroll('', query?.page, '', query?.per_page));
    }
    if (tab === '/profile/wishlist') {
      dispatch(getCourseWishlistByPage(queries));
    }
  }, [tab, query, queries]);

  useEffect(() => {
    if (addCourseWishlistStatus === 'success') {
      dispatch(
        setProfileData({
          name: 'wishlist',
          key: 'data',
          value: wishlist.data.filter((each: any) => each.slug !== removeSlug),
        })
      );
      dispatch(
        setProfileData({
          name: 'wishlist',
          key: 'meta',
          value: {
            ...profileWishlistMeta,
            total: wishlistStatus
              ? profileWishlistMeta?.total + 1
              : profileWishlistMeta?.total > 0
              ? profileWishlistMeta?.total - 1
              : 0,
          },
        })
      );
    }
    setTimeout(
      () =>
        dispatch(
          setCourseEditData({
            key: 'addCourseWishlistStatus',
            value: '',
          })
        ),
      3000
    );
  }, [addCourseWishlistStatus]);

  const onHeartClick = (slug) => {
    dispatch(addCourseToWishList(slug));
    setRemoveSlug(slug);
  };

  const handlePagination = (page: any, pageSize: any) => {
    setQuery({ ...query, page, per_page: pageSize });
  };

  const handleWishlistPagination = (page: any, pageSize: any) => {
    setQueries({ ...queries, page, per_page: pageSize });
  };

  return (
    <>
      <div>
        <Nav className="border-bottom">
          <NavItem className="d-flex flex-row">
            <NavLink
              className={classnames(
                tab === '/profile/my-course'
                  ? 'font-weight-bold text-secondary'
                  : 'text-black'
              )}
              style={
                tab === '/profile/my-course'
                  ? { borderBottom: '3px solid #19569c' }
                  : { borderBottom: '0px' }
              }
              onClick={() => {
                tab !== '/profile/my-course' &&
                  router.push({ pathname: '/profile/my-course' });
              }}
            >
              My Courses
            </NavLink>
            <NavLink
              className={classnames(
                tab === '/profile/wishlist'
                  ? 'font-weight-bold text-secondary'
                  : 'text-black'
              )}
              style={
                tab === '/profile/wishlist'
                  ? { borderBottom: '3px solid #19569c' }
                  : { borderBottom: '0px' }
              }
              onClick={() => {
                tab !== '/profile/wishlist' &&
                  router.push({ pathname: '/profile/wishlist' });
              }}
            >
              Wishlist
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={tab}>
          <TabPane tabId={'/profile/my-course'}>
            {tab === '/profile/my-course' && (
              <>
                <div className="mb-5">
                  {myCourseLoading ? (
                    <div className="row">
                      {[...Array(10)].map((i: number) => (
                        <div className="col-lg-4 my-5">
                          <Skeleton active key={i} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="row">
                      {courses?.length !== 0 ? (
                        courses?.map((course) => (
                          <div className="col-lg-4 mt-4">
                            <MyNewCourseCard course={course} />
                          </div>
                        ))
                      ) : (
                        <Empty className="mt-3" />
                      )}
                      <div className="d-flex justify-content-center ">
                        <Pagination
                          defaultCurrent={query?.page}
                          pageSize={12}
                          total={enrollCourseQuery?.total}
                          onChange={handlePagination}
                          className="mt-5 float-right"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </TabPane>

          <TabPane tabId="/profile/wishlist">
            {tab === '/profile/wishlist' && (
              <>
                {getCourseWishList === 'request' ? (
                  <div className="row">
                    {[...Array(10)].map((i: number) => (
                      <div className="col-lg-4 my-5">
                        <Skeleton active key={i} />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="row">
                    {wishlist?.data?.length !== 0 ? (
                      wishlist?.data?.map((course) => (
                        <div className="col-lg-4 mt-4">
                          <a
                            title={capitalizeFirstLetter(course?.name)}
                            href={`/course/${course.slug}`}
                          >
                            <Card
                              className={`course-item-card border border-18 p-0 w-100`}
                              style={{
                                borderRadius: '15px',
                              }}
                              hoverable
                              cover={
                                <img
                                  alt={course?.name}
                                  style={{
                                    height: '135px',
                                    borderTopLeftRadius: '15px',
                                    borderTopRightRadius: '15px',
                                  }}
                                  src={
                                    course.image
                                      ? course.image
                                      : imagesLink[
                                          Math.floor(
                                            Math.random() * imagesLink.length
                                          )
                                        ]
                                  }
                                />
                              }
                            >
                              <Card.Meta
                                className="d-flex align-items-center"
                                style={{ fontStyle: 'Poppins,sans-serif' }}
                                title={
                                  <span className="text-truncate course-single-name d-flex">
                                    {capitalizeFirstLetter(course?.name)}
                                  </span>
                                }
                              />
                              <div
                                className="position-absolute float-right"
                                style={{
                                  right: '5%',
                                }}
                              >
                                {course?.wishlist ? (
                                  <HeartFilled
                                    rev=""
                                    className="text-danger cursor-pointer mt-1"
                                    style={{ fontSize: '24px', zIndex: '1001' }}
                                    title="Remove from wishlist"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onHeartClick(course?.slug);
                                    }}
                                  />
                                ) : (
                                  <HeartOutlined
                                    rev=""
                                    className={
                                      'text-dark mt-1 cursor-pointer heart-outline'
                                    }
                                    style={{ fontSize: '24px', zIndex: '1001' }}
                                    title="Add to wishlist"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onHeartClick(course?.slug);
                                    }}
                                  />
                                )}
                              </div>

                              <div className="mt-2 mb-2">
                                <span className="course-instructor d-block">
                                  {course?.test?.name ? (
                                    <span
                                      className="text-muted"
                                      style={{ lineHeight: '0.5' }}
                                    >
                                      {capitalizeFirstLetter(course?.test?.name)}
                                    </span>
                                  ) : null}
                                </span>

                                <div className="d-flex justify-content-between">
                                  <>
                                    {course?.coming_soon ? (
                                      <>
                                        <Badge className="p-1 h-25 mt-2 bg-danger shadow-lg rounded">
                                          <span
                                            className="text-white"
                                            style={{
                                              fontSize: '13px',
                                              fontWeight: '500',
                                            }}
                                          >
                                            Coming Soon
                                          </span>
                                        </Badge>
                                      </>
                                    ) : (
                                      <span className="course-rating mt-1">
                                        {course?.total_feedback != 0 ? (
                                          <>
                                            <strong
                                              className="mr-1 mt-1"
                                              style={{
                                                fontSize: '12px',
                                                color: '#fbbc05',
                                              }}
                                            >
                                              {course?.average_rating?.toFixed(1)}
                                            </strong>
                                            <Rate
                                              disabled
                                              allowHalf
                                              defaultValue={course?.average_rating}
                                              style={{
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                color: '#fbbc05',
                                              }}
                                            />
                                            <small
                                              className="ml-1 mt-1 text-muted font-weight-bold reviewtip"
                                              style={{
                                                fontSize: '12px',
                                                lineHeight: '1.8',
                                                fontFamily: 'Poppins sans-serif',
                                              }}
                                            >
                                              ({course?.total_feedback})
                                              <span className="tooltiptext">
                                                No. of Review
                                              </span>
                                            </small>
                                          </>
                                        ) : null}
                                      </span>
                                    )}
                                  </>
                                </div>
                              </div>

                              <div className="mt-3 mb-3 border-bottom-dotted" />
                              <div className="position-relative d-flex justify-content-between">
                                <div
                                  className="go-to-course float-right position-absolute"
                                  style={{
                                    right: '1%',
                                  }}
                                ></div>
                              </div>
                            </Card>
                          </a>
                        </div>
                      ))
                    ) : (
                      <Empty className="mt-3" />
                    )}
                    {wishlist?.data?.length > 0 && (
                      <div className="d-flex justify-content-center ">
                        <Pagination
                          defaultCurrent={queries?.page}
                          pageSize={12}
                          total={wishlist?.meta?.total}
                          onChange={handleWishlistPagination}
                          className="mt-5 float-right"
                        />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};

export default memo(CourseTabs);
